import { render, staticRenderFns } from "./ISO50001.vue?vue&type=template&id=632733ba&scoped=true&"
import script from "./ISO50001.vue?vue&type=script&lang=js&"
export * from "./ISO50001.vue?vue&type=script&lang=js&"
import style0 from "./ISO50001.vue?vue&type=style&index=0&id=632733ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632733ba",
  null
  
)

export default component.exports